var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4030958,3.84 C13.4030958,5.96077362 11.6556205,7.68 9.5,7.68 C7.34437953,7.68 5.5969042,5.96077362 5.5969042,3.84 C5.5969042,1.71922638 7.34437953,0 9.5,0 C11.6556205,0 13.4030958,1.71922638 13.4030958,3.84 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16 C1.43700179,13.6418646 4.58644137,12.027937 9.5,12.027937 C14.4135586,12.027937 17.5629982,13.6418646 19,16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.221ec31ba9b61e3ddcfa3c83da75e9da.svg";
export { ForwardRef as ReactComponent };